<template lang="pug">
    .form-container.outer
        .form-form
            .form-form-wrap
                .form-container
                    .form-content
                        img.mb-2(src='../assets/img/logo_login.png')
                        p.text-white.mt-2 Inicia sesión en tu cuenta para continuar:
                        form.text-left
                            .form
                                #username-field.field-wrapper.input
                                    label.text-white(for='username') USUARIO
                                    svg.feather.feather-user(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
                                        path(d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2')
                                        circle(cx='12' cy='7' r='4')
                                    input#username.form-control(name='username' type='text' placeholder='Nombre de usuario' v-model="model.sUserName")
                                #password-field.field-wrapper.input.mb-2
                                    .d-flex.justify-content-between
                                        label.text-white(for='password') CONTRASEÑA
                                    svg.feather.feather-lock(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
                                        rect(x='3' y='11' width='18' height='11' rx='2' ry='2')
                                        path(d='M7 11V7a5 5 0 0 1 10 0v4')
                                    input#password.form-control(name='password' :type='passwordType' placeholder='Contraseña' v-model="model.sPassword")
                                    svg#toggle-password.feather.feather-eye(@click="showPassword()" xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
                                        path(d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z')
                                        circle(cx='12' cy='12' r='3')
                                .d-sm-flex.justify-content-between
                                    .field-wrapper
                                        button.btn.btn-info(type="button" value="" @click="login()") Iniciar sesión
                                p.signup-link.text-white  ¿No tienes una cuenta? 
                                    a.text-warning(href="#" @click.prevent="register()") Regístrate
                                    //router-link(class="text-warning" to="/register") Regístrate


</template>
<script>
/* eslint-disable */
export default {
    name: 'Login',
    data() {
        return {
            passwordType: 'Password',
            model: {
                sUserName: '',
                sPassword: ''
            }
        }
    },
    methods: {
        register(){
            router.push("/register")
            localStorage.isRCSA = 0
        },
        showPassword(){
            if(this.passwordType == "Password"){
                this.passwordType = "Text"
            }
            else{
                this.passwordType = "Password"
            }
        },
        async login() {
            this.openLoading('Espere por favor...')
            axios.post(apiURL + 'Login', this.model)
            .then( (response) => {
                Swal.close()
                if(response.data.sErrors.length == 0){
                    localStorage.idActivation = response.data.idActivation
                    localStorage.setItem("dataPerson", JSON.stringify(response.data.userData))
                    localStorage.userToken = response.data.sToken
                    localStorage.isRCSA = 0

                    if(response.data.userData.idSelectedRol == 4)
                        router.push('/TeacherHome')
                    else if(response.data.userData.idSelectedRol == 5)
                        router.push('/StudentHome')
                    else if(response.data.userData.idSelectedRol == 1 || response.data.userData.idSelectedRol==2 || response.data.userData.idSelectedRol==3)
                        router.push('/AdminHome')
                }
                else
                    Swal.fire(response.data.sErrors[0])
            } )
            .catch( (error) => {
                Swal.close()
                Swal.fire(error)
            } )
        }
    },
    beforeMount() {
        document.body.style.backgroundImage = null;
        document.body.classList.add('form', 'bg-img')
        document.body.style.backgroundImage = "url('assets/img/bg-login.jpg')"
    },
    destroyed() {
        //document.body.classList.remove('form', 'bg-img')

        //document.body.classList.remove('hold-transition', 'login-page')
    },
    mounted() {

    }
}
</script>
<style scoped>
    @import 'https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,300;0,400;0,700;0,900;1,400&display=swap';

</style>